@if (hasAccess === false) {
  <app-access-denied [reason]="accessDeniedReason"></app-access-denied>
} @else {
@if (!isInitializing && showFirstConfigurationOverlay) {
  <div
    class="fixed inset-0 z-[2000] flex items-center justify-center bg-black/50 p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'firstConfiguration.header' | translate"
  >
    <div class="w-full max-w-lg rounded-2xl bg-white dark:bg-[var(--color-bunker-500)] shadow-2xl border border-gray-200 dark:border-gray-700">
      <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h1 class="text-lg font-semibold text-gray-900 dark:text-gray-100 m-0">
          {{ 'firstConfiguration.header' | translate }}
        </h1>
      </div>
      <app-first-configuration />
    </div>
  </div>
}

@if (!isInitializing && showCompanyDataOverlay) {
  <div
    class="fixed inset-0 z-[2000] flex items-center justify-center bg-black/50 p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'companyDataRequired.header' | translate"
  >
    <div
      class="w-full max-w-lg rounded-2xl bg-white dark:bg-[var(--color-bunker-500)] shadow-2xl border border-gray-200 dark:border-gray-700"
      (click)="$event.stopPropagation()"
    >
      <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h1 class="text-lg font-semibold text-gray-900 dark:text-gray-100 m-0">
          {{ 'companyDataRequired.header' | translate }}
        </h1>
      </div>
      <app-company-data-required />
    </div>
  </div>
}

@if (!isInitializing) {
<div class="eko-shell-viewport flex flex-col h-full min-h-0 overflow-hidden">
  <eko-layout-app-bar
   [logoSrc]="'assets/ui/img/logo.png'"
    [logoAlt]="'Ekowitryna'"
    [logoTitle]="'app.brand' | translate"
    [sidebarCollapsed]="sidebarCollapsed"
    [currentUser]="currentUser"
    [authenticated]="authenticated"
    [availableLanguages]="availableLanguages"
    [currentLanguage]="currentLanguage"
    [profileExternalUrl]="profileExternalUrl"
    [profileExternalNewTab]="false"
    [profileActions]="profileActions"
    [keycloakUrl]="keycloakUrl"
    [keycloakRealm]="keycloakRealm"
    [keycloakClientId]="keycloakClientId"
    [showSearch]="false"
    [loginLabel]="loginLabel"
    [userMenuLabel]="userMenuLabel"
    [myProfileLabel]="myProfileLabel"
    [logoutLabel]="logoutLabel"
    [buySubscriptionLabel]="buySubscriptionLabel"
    [subscriptionUrl]="subscriptionUrl"
    [themeLabel]="themeLabel"
    [languageLabel]="languageLabel"
    [toggleSidebarLabel]="toggleSidebarLabel"
    (sidebarToggle)="onSidebarToggle()"
    (profileAction)="onProfileAction($event)"
    (languageChange)="onLanguageChange($event)"
>
  </eko-layout-app-bar>
  <div class="eko-shell-grid grid w-full min-w-0 flex-1 bg-gray-25 relative grid-cols-1 lg:grid-cols-[auto_minmax(0,1fr)]">
    @if (isMobile && !sidebarCollapsed) {
      <div
        class="sidebar-backdrop fixed inset-0 bg-black/40 z-[900] lg:hidden"
        (click)="closeSidebarMobile()"
        role="button"
        [attr.aria-label]="'a11y.closeMenu' | translate"
      ></div>
    }
    <div class="eko-shell-sidebar-host max-lg:absolute max-lg:w-0 max-lg:min-h-0 max-lg:overflow-visible bg-gray-25 dark:bg-[var(--color-bunker-500)]">
      <eko-layout-sidebar
        [collapsed]="sidebarCollapsed">
        <div slot="sidebar-nav">
          <app-company-context-panel></app-company-context-panel>
          <eko-navigation-menu
            [items]="navigationItems"
            [currentRoute]="currentRoute"
            [expandAllByDefault]="true"
            (itemClick)="onMenuClick($event)"
            (menuClosed)="onMenuClosed()">
          </eko-navigation-menu>
        </div>
        <p slot="sidebar-footer" class="sidebar-version-footer m-0">{{ appVersion }}</p>
      </eko-layout-sidebar>
    </div>
    <main class="eko-shell-main min-w-0 w-full p-1 md:p-4 max-w-full bg-gray-25 dark:bg-[var(--color-bunker-400)]">
      <div class="grid grid-cols-1">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
<eko-scroll-to-top />
}
}
